import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/store/auth';
import { RouteFallback } from './RouteFallback';

/**
 * Gates the sender surface. This is a UX guard only - every endpoint and every
 * Firestore rule re-checks the caller server-side.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const user = useAuth((s) => s.user);
  const loading = useAuth((s) => s.loading);
  const location = useLocation();

  if (loading) return <RouteFallback />;

  if (!user || user.isAnonymous) {
    // Preserve the intended destination so sign-in can bounce back to it.
    return <Navigate to="/auth/sign-in" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
